"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateWizardState = void 0;
var state_1 = require("../state");
var fieldHandler_1 = require("./fieldHandler");
var arrayEquals = function (a, b) { return JSON.stringify(a) === JSON.stringify(b); };
var updateWizardState = function () {
    var wizard = state_1.state.wizard;
    var newWizardState = __assign({}, wizard);
    for (var i = 1; i <= state_1.state.activeStep; i++) {
        var pane = document.querySelector('[data-advisor-step="' + i + '"]');
        if (!pane) {
            continue;
        }
        var fieldGroup = pane.dataset.advisorFieldset;
        var parsedFields = fieldHandler_1.getFieldValues(pane);
        switch (fieldGroup) {
            case 'location':
                newWizardState.location = parsedFields;
                break;
            case 'income':
                newWizardState.income = parsedFields;
                break;
            case 'assets':
                newWizardState.assets = parsedFields;
                break;
            case 'occupation':
                newWizardState.occupation = parsedFields;
                break;
            case 'age':
                newWizardState.age = parsedFields;
                break;
            case 'goals':
                newWizardState.goals = parsedFields;
                break;
        }
    }
    // Only update if something has changed. Since other functions are watching
    if (!arrayEquals(wizard, newWizardState)) {
        state_1.setState({ 'wizard': newWizardState });
    }
};
exports.updateWizardState = updateWizardState;
exports.default = (function () {
    var radioButtons = Array.from(document.querySelectorAll('.FAForm input[type=radio]'));
    radioButtons.map(function (btn) { return btn.addEventListener('click', exports.updateWizardState); });
});
